import { Color } from './color';
import { Theme, ThemeType } from './themesModel';

export const THEMES: Record<ThemeType, Theme> = {
  light: {
    '--backGroundColor': Color.BG_LIGHT,
    '--textColor': Color.SECONDARY,
    '--gradientStartCold': Color.GRADIENT_START_COLD,
    '--gradientEndCold': Color.GRADIENT_END_COLD,
    '--gradientStartHot': Color.GRADIENT_START_HOT,
    '--gradientEndHot': Color.GRADIENT_END_HOT,
    '--darkBlue': Color.DARK_BLUE,
    '--searchIcon': Color.SEARCH_ICON,
    '--rating': Color.RATING,
    '--noteBorder': Color.NOTE_BORDER,
    '--opacityBGImage': Color.OPACITY_BG_IMG,
    '--boxShadowTB': Color.BOX_SHADOW_TB,
    '--boxShadowMB': Color.BOX_SHADOW_TB,
    '--cardBG': Color.PRIMARY,
    '--cardText': Color.CARD_TEXT,
    '--navListTextColor': Color.GRADIENT_END_COLD,
    '--textButton': Color.PRIMARY,
    '--breadCrumbColor': Color.SECONDARY,
    '--toggleBackGround': Color.PRIMARY,
    '--inputBG': Color.INPUT_BG_COLOR_LIGHT,
    '--inputText': Color.INPUT_TEXT_COLOR_LIGHT,
    '--cardShadow': Color.CARD_SHADOW_LIGHT,
    '--numGradientEnd': Color.LIGHT_GRAY,
    '--footerBoxShadow': Color.FOOTER_SHADOW_DARK,
    '--footerText': Color.GRADIENT_START_COLD,
  },
  dark: {
    '--backGroundColor': Color.BG_DARK,
    '--textColor': Color.PRIMARY,
    '--gradientStartCold': Color.GRADIENT_START_COLD,
    '--gradientEndCold': Color.GRADIENT_END_COLD,
    '--gradientStartHot': Color.GRADIENT_START_HOT,
    '--gradientEndHot': Color.GRADIENT_END_HOT,
    '--darkBlue': Color.DARK_BLUE,
    '--searchIcon': Color.SEARCH_ICON,
    '--rating': Color.RATING,
    '--noteBorder': Color.NOTE_BORDER,
    '--opacityBGImage': Color.OPACITY_BG_IMG,
    '--boxShadowTB': Color.BOX_SHADOW_TB,
    '--boxShadowMB': Color.BOX_SHADOW_MB,
    '--cardBG': Color.CARD_BG,
    '--cardText': Color.PRIMARY,
    '--navListTextColor': Color.GRADIENT_START_COLD,
    '--textButton': Color.PRIMARY,
    '--breadCrumbColor': Color.SECONDARY,
    '--toggleBackGround': Color.DARK_BLUE,
    '--inputBG': Color.DARK_BLUE,
    '--inputText': Color.PRIMARY,
    '--cardShadow': Color.CARD_SHADOW_DARK,
    '--numGradientEnd': Color.DARK_BLUE,
    '--footerBoxShadow': Color.FOOTER_SHADOW_DARK,
    '--footerText': Color.PRIMARY,
  },
};
